module.exports = __webpack_public_path__ + "img/bookmark-minus.3c286696.svg";